import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import Flex from 'Components/UI/_Legacy/Flex.js'

export default styled(Flex)`
  width: 100%;
  min-height: 100vh;
  justify-content: center;
  background-color: ${themeGet(`colors.secondary`)};
  color: ${themeGet(`colors.font.secondary`)};
`
